import APIService from '.';

export default class ImageUploadService extends APIService {
  upload(image: FormData) {
    return this.post('/storage/upload/image', image);
  }

  uploadCoinImage(image: FormData, recaptcha?: string) {
    return this.post('/storage/upload/coin', image, {
      ...(recaptcha && { headers: { recaptcha } })
    });
  }

  uploadDealImage(businessId: string, form: FormData) {
    return this.post(`/super-admin/business/${businessId}/deal-image`, form);
  }

  uploadCoverCapImage(businessId: string, form: FormData) {
    return this.post(
      `/super-admin/business/${businessId}/cover-cap-image`,
      form
    );
  }

  getImageIdByPath(filepath: string): Promise<{ data: { id: string } }> {
    return this.post('/storage/image-db', {
      filepath
    });
  }
}
